"use strict";

function _boolean(obj, key) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return obj[key] === value;
}

module.exports = _boolean;